import styled, { css } from 'styled-components';
import { MenuItemButton, MenuItem } from '../Menu';
import kebabCase from 'hs-lodash/kebabCase';
import { useAppSelector } from '../../hooks';
import { selectObjBuilderMenuItems } from '../../selectors';
import memoWithDisplayName from '../../utils/memoWithDisplayName';
import { navTheme } from '../../theme/nav-theme';
import { usePortal } from '../../hooks/useNavConfig';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const getMenuItemStyles = ({
  theme
}) => {
  return css(["border-radius:6px;list-style-type:none;a,button{width:100%;text-align:left;background:transparent;border:0;color:", " !important;-webkit-font-smoothing:auto;-moz-osx-font-smoothing:auto;font-size:14px !important;font-weight:300 !important;line-height:24px !important;padding:8px 16px !important;text-decoration:none !important;cursor:pointer;}&:hover{background:", ";}"], navTheme(theme).navTextSecondary, navTheme(theme).navBgTertiary);
};
const StyledMenuItem = styled(MenuItem)(getMenuItemStyles);
const StyledMenuItemButton = styled(MenuItemButton)(getMenuItemStyles);
export const ObjectCreateMenu = memoWithDisplayName('ObjectCreateMenu', ({
  onMenuItemClicked
}) => {
  const filteredMenuItems = useAppSelector(selectObjBuilderMenuItems);
  const {
    portalId
  } = usePortal();
  return /*#__PURE__*/_jsx(_Fragment, {
    children: filteredMenuItems.map(item => {
      const id = `hs-nav-object-create-menu-item-${kebabCase(item.id)}`;
      if (item.id === 'createAppListing') {
        return /*#__PURE__*/_jsx(StyledMenuItem, {
          id: id,
          href: `/marketplace-providers/${portalId}/apps/available`,
          "data-test-id": id,
          children: item.label
        }, item.id);
      }
      return /*#__PURE__*/_jsx(StyledMenuItemButton, {
        id: id,
        "data-test-id": id,
        onClick: () => onMenuItemClicked(item),
        "data-click-action": "Create object",
        children: item.label
      }, item.id);
    })
  });
});